export enum AttractionFunFactKindEnum {
    FACT = 'fact',
    LEGEND = 'legend',
}
